import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { shouldShowInScopeSelector } from "owa-mail-search-utils";
import type { SearchScope } from "owa-search-service";
import isGenWebQueryOnTypeEligible from "./isGenWebQueryOnTypeEligible";

export default function shouldDisableSuggestionsCallout(initialSearchScope: SearchScope, staticSearchScope: SearchScope | undefined, mailboxInfo: MailboxInfo): boolean {
    return (!shouldShowInScopeSelector(initialSearchScope) ||
        (isGenWebQueryOnTypeEligible(staticSearchScope, mailboxInfo) &&
            !isAccountFeatureEnabled("sea-gwc-query-on-type-with-qf", mailboxInfo)));
}
